import type { BadgeVariant } from "@/components/badge";

/**
 * Unified status color mapping for consistency across request list and edit pages
 * Maps status IDs from RequestStatusEnum to BadgeVariant values
 */
export const STATUS_COLOR_MAP = {
  1: "orange-vibrant", // AwaitingResponse
  10: "black", // Completed
  11: "pink-dark-vibrant", // Resizing
  12: "red-vibrant", // Redesigning
  13: "black", // Archived
  2: "pink-vibrant", // BeingRevised
  3: "warning-vibrant", // ReadyForReview
  4: "blue-light", // ProcessingRequest
  5: "purple", // InQueue
  6: "success-vibrant", // DesignInProgress (Scheduled)
  7: "blue-vibrant", // Scheduling
  8: "error", // Paused
  9: "warning", // DetailsNeeded
} as const;

/**
 * Get the badge variant color for a given status ID
 */
export const getStatusColor = (statusId: number): BadgeVariant =>
  STATUS_COLOR_MAP[statusId as keyof typeof STATUS_COLOR_MAP] ?? "primary";

/**
 * Status options for edit page dropdowns with unified colors
 */
export const STATUS_OPTIONS = [
  { id: 7, label: "Scheduling", variant: STATUS_COLOR_MAP[7] },
  { id: 6, label: "Scheduled", variant: STATUS_COLOR_MAP[6] },
  { id: 3, label: "Ready for review", variant: STATUS_COLOR_MAP[3] },
  { id: 1, label: "Response needed", variant: STATUS_COLOR_MAP[1] },
  { id: 2, label: "Revising", variant: STATUS_COLOR_MAP[2] },
  { id: 11, label: "Resizing", variant: STATUS_COLOR_MAP[11] },
  { id: 12, label: "Redesigning", variant: STATUS_COLOR_MAP[12] },
  { id: 13, label: "Archived", variant: STATUS_COLOR_MAP[13] },
  { id: 4, label: "Scoping", variant: STATUS_COLOR_MAP[4] },
  { id: 9, label: "Details needed", variant: STATUS_COLOR_MAP[9] },
  { id: 8, label: "Paused", variant: STATUS_COLOR_MAP[8] },
  { id: 5, label: "Queued", variant: STATUS_COLOR_MAP[5] },
  { id: 10, label: "Completed", variant: STATUS_COLOR_MAP[10] },
] as const;
